import { Box, SpaceBetween, Link, Icon } from "@cloudscape-design/components";
import { useLocation } from 'react-router-dom';
import { IconProps } from "@cloudscape-design/components/icon";

interface NavItem {
  href: string;
  icon: IconProps.Name;
  text: string;
}

export default function AccountSettingsNavigation() {
  const location = useLocation();
  const currentPath = location.hash;

  const navItems: NavItem[] = [
    { href: '#/profile', icon: 'user-profile', text: 'Profile' },
    { href: '#/security', icon: 'key', text: 'Security' },
    { href: '#/device-activity', icon: 'multiscreen', text: 'Device activity' },
    { href: '#/linked-accounts', icon: 'share', text: 'Linked accounts' },
  ];

  return (
    <Box padding={{ horizontal: 'm' }}>
      <SpaceBetween size="l">
        <div className="profile-navigation">
          {navItems.map((item) => (
            <Link key={item.href} href={item.href}>
              <div className={`profile-tab ${currentPath === item.href ? 'active-tab' : ''}`}>
                <Icon name={item.icon} />
                <Box className="organization-button" margin={{ left: 'xs' }}>{item.text}</Box>
              </div>
            </Link>
          ))}
        </div>
      </SpaceBetween>
    </Box>
  );
}
